module.exports = __webpack_public_path__ + "media/images/social-preview-banner-7192ab36dc22828059b74b5670feb550.jpg";